import {MetricInfo} from "framework/entities/metricInfo";

import {MetricConfiguration, MetricConfigurationUnitType} from "areas/metrics/components/MetricSelector/types";

export function getUnitType(metricConfiguration: MetricConfiguration, metric: MetricInfo) {
	const unitType = metricConfiguration.unit

	if (unitType == MetricConfigurationUnitType.Custom) {
		return metricConfiguration.unitLabel;
	}

	return metric.qualifier.unitTypeSymbol
}

